// extracted by mini-css-extract-plugin
export var internalNoteEditor = "_gb-1";
export var quotedThread = "_gb-0";